import { useContext, useState } from "react";
import { createUserAddress } from "../../../components/users/functions";
import { isNumeric } from "../../../components/utils/functions";
import ToastContext from "../../../context/toastProvider";
import MobileFilterSheet from "../../ui/MobileFilterSheet";
import MobileFormField from "../../ui/MobileFormField";

const inputClass =
  "w-full min-h-[44px] rounded-lg border border-primary/50 bg-monao px-3 text-base text-laranjinha";
const primaryBtn =
  "inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg bg-primary px-4 text-sm font-medium text-mgs-bg hover:bg-[#b47c06] disabled:opacity-50";
const secondaryBtn =
  "inline-flex min-h-[44px] flex-1 items-center justify-center rounded-lg border border-primary/50 px-4 text-sm font-medium text-laranjinha/80 hover:bg-monao disabled:opacity-50";

export default function MobileNewAddressSheet({
  open,
  onClose,
  user,
  userId,
  onCreated,
}) {
  const { goodToast, badToast } = useContext(ToastContext);

  const [loading, setLoading] = useState(false);
  const [noCEP, setNoCEP] = useState(false);
  const [name, setName] = useState("");
  const [cep, setCep] = useState("");
  const [street, setStreet] = useState("");
  const [district, setDistrict] = useState("");
  const [houseNumber, setHouseNumber] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [reference, setReference] = useState("");
  const [complement, setComplement] = useState("");

  const resetForm = () => {
    setName("");
    setCep("");
    setStreet("");
    setDistrict("");
    setHouseNumber("");
    setCity("");
    setState("");
    setReference("");
    setComplement("");
    setNoCEP(false);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const searchCEP = async (postal) => {
    try {
      setLoading(true);
      const response = await fetch(`https://viacep.com.br/ws/${postal}/json/`);
      if (response.ok) {
        setNoCEP(false);
        const data = await response.json();
        if (data.erro) {
          setNoCEP(true);
          return;
        }
        setStreet(data.logradouro);
        setDistrict(data.bairro);
        setCity(data.localidade);
        setState(data.uf);
      } else {
        setNoCEP(true);
      }
    } catch {
      setNoCEP(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCep = (value) => {
    const tempValue = value?.split("-")?.join("");
    if (isNumeric(tempValue)) {
      setCep(tempValue);
      if (tempValue.length === 8) {
        searchCEP(tempValue);
      }
    }
  };

  const disableSubmit =
    !cep || !name || !street || !state || !district || !houseNumber;

  const handleSubmit = async () => {
    if (disableSubmit || loading) return;
    setLoading(true);
    const body = {
      userId,
      receiver: name,
      name,
      postalCode: cep,
      street,
      district,
      houseNumber,
      city,
      state,
      complement,
      reference,
    };
    const data = await createUserAddress(user?.token, body);
    if (data?.type !== "success") {
      badToast(data?.message || "Erro ao criar endereço");
      setLoading(false);
      return;
    }
    goodToast("Endereço criado!");
    resetForm();
    setLoading(false);
    onCreated?.();
    onClose();
  };

  return (
    <MobileFilterSheet open={open} onClose={handleClose} title="Novo endereço">
      <MobileFormField label="Nome do recebedor">
        <input
          className={inputClass}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nome"
        />
      </MobileFormField>
      <MobileFormField label="CEP">
        <div className="flex gap-2">
          <input
            className={inputClass}
            value={cep}
            onChange={(e) => handleCep(e.target.value)}
            placeholder="00000000"
          />
          <button
            type="button"
            className={secondaryBtn}
            onClick={() => searchCEP(cep)}
            disabled={loading || !cep}
          >
            Buscar
          </button>
        </div>
        {noCEP ? (
          <p className="mt-1 text-xs text-red-500">CEP não encontrado</p>
        ) : null}
      </MobileFormField>
      <MobileFormField label="Logradouro">
        <input
          className={inputClass}
          value={street}
          onChange={(e) => setStreet(e.target.value)}
        />
      </MobileFormField>
      <MobileFormField label="Número">
        <input
          className={inputClass}
          value={houseNumber}
          onChange={(e) => setHouseNumber(e.target.value)}
        />
      </MobileFormField>
      <MobileFormField label="Complemento">
        <input
          className={inputClass}
          value={complement}
          onChange={(e) => setComplement(e.target.value)}
        />
      </MobileFormField>
      <MobileFormField label="Bairro">
        <input
          className={inputClass}
          value={district}
          onChange={(e) => setDistrict(e.target.value)}
        />
      </MobileFormField>
      <MobileFormField label="Cidade">
        <input
          className={inputClass}
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
      </MobileFormField>
      <MobileFormField label="Estado">
        <input
          className={inputClass}
          value={state}
          onChange={(e) => setState(e.target.value)}
        />
      </MobileFormField>
      <MobileFormField label="Ponto de referência">
        <input
          className={inputClass}
          value={reference}
          onChange={(e) => setReference(e.target.value)}
        />
      </MobileFormField>
      <div className="mt-4 flex gap-3">
        <button type="button" className={secondaryBtn} onClick={handleClose}>
          Cancelar
        </button>
        <button
          type="button"
          className={primaryBtn}
          disabled={disableSubmit || loading}
          onClick={handleSubmit}
        >
          {loading ? "Salvando…" : "Salvar"}
        </button>
      </div>
    </MobileFilterSheet>
  );
}
